import { configureStore } from "@reduxjs/toolkit";
import HomeReducer from "./HomeReducer";
import PolistingReducer from "./PolistingReducer";
import PointsReducer from "./PointsReducer";

export default configureStore({
  reducer: {
    // tableOverview: TableOverviewReducer,
    // infoPanel: InfoPanelReducer,
    home: HomeReducer,
    poListing: PolistingReducer,
    points: PointsReducer,
  },
});
